"use client";

import { X } from "lucide-react";

const STYLES = {
    success: "border-l-4 border-l-success bg-surface text-text-primary",
    error: "border-l-4 border-l-danger bg-surface text-text-primary",
    info: "border-l-4 border-l-interactive bg-surface text-text-primary",
} as const;

type Props = {
    message: string;
    type?: keyof typeof STYLES;
    onClose?: () => void;
    children?: React.ReactNode;
};

export function Toast({ message, type = "info", onClose, children }: Props) {
    return (
        <div className={`rounded shadow-lg px-4 py-3 min-w-64 max-w-sm ${STYLES[type]}`}>
            <div className="flex items-start justify-between gap-3">
                <p className="text-sm">{message}</p>
                {onClose && (
                    <button
                        onClick={onClose}
                        className="shrink-0 text-text-muted hover:text-text-primary"
                        aria-label="閉じる"
                    >
                        <X size={16} />
                    </button>
                )}
            </div>
            {children && <div className="mt-2">{children}</div>}
        </div>
    );
}
